var _path, _rect, _rect2, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb17(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.34 241",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-lightbulb-outline",
    "data-name": "Icon material-lightbulb-outline",
    d: "M102.16,232.33a8.67,8.67,0,0,0,8.67,8.67H145.5a8.68,8.68,0,0,0,8.66-8.67h0v-8.66h-52Zm26-164.66A60.66,60.66,0,0,0,93.5,178.08v19.59a8.66,8.66,0,0,0,8.66,8.66h52a8.68,8.68,0,0,0,8.67-8.66V178.08A60.67,60.67,0,0,0,128.16,67.67Zm24.7,96.2-7.36,5.2V189H110.83V169.07l-7.37-5.2a43.34,43.34,0,1,1,49.4,0Z",
    transform: "translate(0.01 0)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.84,
    width: 16.67,
    height: 49.17
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 115.67,
    width: 49.17,
    height: 16.67
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 207.17,
    y: 115.67,
    width: 49.17,
    height: 16.67
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 179.69,
    y: 46.85,
    width: 49.17,
    height: 16.67,
    transform: "translate(20.82 160.61) rotate(-45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.64,
    y: 30.6,
    width: 16.67,
    height: 49.17,
    transform: "translate(-23.79 52.92) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb17);
export default __webpack_public_path__ + "static/media/lightbulb[17].7a2e99e28140c27e1bfaa7e2465d9ff8.svg";
export { ForwardRef as ReactComponent };